var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.475 10.77c-.365-.075-.803.15-.876.527-.73 3.088-3.358 5.197-6.424 5.197-3.65 0-6.642-3.088-6.642-6.854 0-3.765 2.993-6.853 6.642-6.853 1.68 0 3.358.677 4.526 1.883h-3.066a.743.743 0 0 0-.73.753c0 .376.293.753.73.753h4.526c.365 0 .73-.302.73-.753V.753c0-.377-.292-.753-.73-.753a.743.743 0 0 0-.73.753V3.39a7.83 7.83 0 0 0-5.329-2.11C4.65 1.28 1 5.047 1 9.64 1 14.234 4.65 18 9.102 18c3.723 0 6.935-2.636 7.884-6.326.073-.377-.146-.753-.51-.904Z"
  })));
};

export default SvgRefresh;